import { h } from 'preact';
import style from './style.css';
import cx from 'classnames';
import { slide as Menu } from 'react-burger-menu';

const CALENDLY_URL =
	process.env.NODE_ENV === 'production'
		? 'https://calendly.com/player-index/demo'
		: 'https://calendly.com/playerindex-qa/30min';

const Header = props => (
	<header>
		<div className={cx(style.nav, 'justify-between')}>
			<div className={cx(style.navBarLeft, 'flex', 'flex-1')}>
				<div className={cx(style.nameLogo, 'flex')}>
					<a href={props.leadingSlash + '#home'}>
						<img src={'/assets/playerIndexLogo.png'} />
					</a>
				</div>
				<ul className={cx('flex', 'flex-1')}>
					<li>
						<a href={props.leadingSlash + '#home'}>HOME</a>
					</li>
					<li>
						<a href={props.leadingSlash + '#what'}>WHAT</a>
					</li>
					<li>
						<a href={props.leadingSlash + '#how'}>HOW</a>
					</li>
					<li>
						<a href={props.leadingSlash + '#business'}>BUSINESS</a>
					</li>
					<li>
						<a href={props.leadingSlash + '#contact-us'}>CONTACT US</a>
					</li>
				</ul>
			</div>
			<div className={cx(style.navBarRight, 'flex', 'flex-1')}>
				<ul className={cx('flex', 'flex-1')}>
					<li
						className={cx('flex', 'flex-1', 'items-center', 'justify-center')}
					>
						<a href={props.leadingSlash + '#our-team'}>ABOUT US</a>
					</li>
					<li
						className={cx('flex', 'flex-2', 'items-center', 'justify-center')}
					>
						<a href="#" onClick={() => Calendly.showPopupWidget(CALENDLY_URL)}>
							SCHEDULE A DEMO
						</a>
					</li>
				</ul>
			</div>
		</div>
		<div className={cx(style.burgerMenu)}>
			<div className={cx(style.nameLogo, 'flex')}>
				<a href={props.leadingSlash + '#home'}>
					<img src={'/assets/playerIndexLogo.png'} />
				</a>
			</div>
			<Menu right isOpen={false}>
				<a href={props.leadingSlash + '#home'}>
					<img src={'/assets/playerIndexLogo.png'} />
				</a>
				<a href={props.leadingSlash + '#home'}>HOME</a>
				<a href={props.leadingSlash + '#what'}>WHAT</a>
				<a href={props.leadingSlash + '#how'}>HOW</a>
				<a href={props.leadingSlash + '#business'}>BUSINESS</a>
				<a href={props.leadingSlash + '#our-team'}>ABOUT US</a>
				<a href={props.leadingSlash + '#contact-us'}>CONTACT US</a>
			</Menu>
		</div>
	</header>
);

export default Header;



// WEBPACK FOOTER //
// ./components/Header/index.jsx